import React from 'react';
import PropTypes from 'prop-types';

const DemandBadge = ({ enabled, demandStatus }) => {
  if (!enabled || demandStatus !== 'hot') return null;

  return (
    <span
      className="small ml-1"
      style={{
        color: '#d32f2f',
        padding: '2px 6px',
        borderRadius: '4px',
        border: '1px solid #d32f2f',
        backgroundColor: '#fef2f2',
        fontSize: '11px',
        fontWeight: 500
      }}
    >
      Hot
    </span>
  );
};

DemandBadge.propTypes = {
  enabled: PropTypes.bool,
  demandStatus: PropTypes.string
};

export default DemandBadge;
